import { useContext } from "react";
import MainContext from "../../context/main/mainContext";

export default function HeaderBarQuote({ team }) {
  const { snackbarAction } = useContext(MainContext);
  const isUpdateMode = Boolean(team?.stripeSubscription);
  const subscriptionLabel = team?.stripeSubscription
    ? team.stripeSubscription.split("%")[1]
    : "N/A";

  const handleCopy = (e) => {
    navigator.clipboard.writeText(e.target.textContent);

    snackbarAction({
      message: `Copied ${e.target.textContent}`,
      severity: "info",
      duration: 3000,
    });
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Team Subscription</h1>
          <p className="text-sm text-gray-500 mt-1">
            Manage subscription settings and enrichment configurations
          </p>
        </div>

        <div className="flex items-center gap-3">
          <div className="text-right">
            <div className="text-xs font-medium text-gray-500 uppercase tracking-wide">Mode</div>
            <div className="text-sm font-semibold text-gray-900">
              {isUpdateMode ? "Update" : "Create"}
            </div>
          </div>
          <div className="h-12 w-px bg-gray-200" />
          <div className="text-right">
            <div className="text-xs font-medium text-gray-500 uppercase tracking-wide" >Team</div>
            <div className="text-sm font-semibold text-gray-900 cursor-pointer" onClick={handleCopy}>{team?.id || "Unknown"}</div>
          </div>
          <div className="h-12 w-px bg-gray-200" />
          <div className="text-right">
            <div className="text-xs font-medium text-gray-500 uppercase tracking-wide">
              Subscription:
            </div>
            <div className="text-sm font-semibold text-gray-900 cursor-pointer" onClick={handleCopy}>{subscriptionLabel}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
